import React, { useLayoutEffect, useState } from "react";
import { useUserContext } from "src/contexts/userContext";
import * as API from "src/api/request";

import { Select } from "antd";
import _ from "lodash";

/**
 * DepartmentTseh — Цех сонгох Select.
 *
 * onChange(departmentcode, parentId, departmentname)
 *   - parentId нь DepartmentNegj-ийн `paranetid` болж хэсгүүдийг шүүхэд хэрэглэгдэнэ.
 *   - Өмнө нь зөвхөн departmentcode дамждаг байсан тул хэсгийн жагсаалт хоосон
 *     гардаг алдааг засав.
 *
 * Props:
 *   value, onChange — стандарт Select-ийн props
 *   disabled        — disable Select
 *   noAutoSelect    — true бол хэрэглэгчийн өөрийн цехийг анхдагчаар сонгохгүй
 *                     (бүх эрхтэй админ хэрэглэгчид "Бүгд" төлөвт үлдээх)
 *   autoSelectOwn   — ⭐ true бол «Бүгд» харах эрхтэй хэрэглэгчид (админ,
 *                     ХАБЭА хэлтэс) ЧУ өөрийн цехийг анхдагчаар сонгоно.
 *
 *                     ЯАГААД: самбар, тооцооны хуудсанд бүх нэгжийн дата нэг
 *                     дор ачаалагдвал удаан бөгөөд «миний нэгжид юу болж
 *                     байна» гэдэг нь харагддаггүй. Хэрэглэгч «Бүгд»-ийг
 *                     гараар сонгож болно.
 *                     `noAutoSelect` нь үүнээс ДАВУУ (хоюулыг өгвөл сонгохгүй).
 *   showAll         — true бол «Бүгд» сонголтыг БҮЛГЭЭС ҮЛ ХАМААРАН харуулна.
 *                     Авто-сонголтын дүрэмд нөлөөлөхгүй (зөвхөн жагсаалтад
 *                     «Бүгд» нэмнэ).
 *
 *                     ЯАГААД: ХСБ-ний тайлан (product/report) зэрэг зарим
 *                     хуудасны backend нь department_code=0-ийг бүх нэгжээр
 *                     өөрөө боловсруулдаг бөгөөд тухайн модулийн хариуцсан
 *                     мэргэжилтэн (ж: 380 — ХАБЭА хэлтсийн ХСБ хариуцсан)
 *                     167-той давхар байвал, эсвэл 384/400 бүлэгтэй бол
 *                     доорх ерөнхий дүрмээр «Бүгд» харагдахгүй байсан
 *                     (2026-10-09, М.Болормаа 68688).
 *   stage           — ⭐ хяналтын ШАТ ("IV" гэх мэт). Backend-д дамжиж
 *                     хамрах хүрээг тодорхойлно: "IV" үед 4 дүгээр
 *                     шатны эрхтэй хүнд үйлдвэрийн БҮХ нэгж гарна,
 *                     бусад үед зөвхөн өөрийн нэгж.
 *
 *                     ЯАГААД: 4 дүгээр шатны хяналт бүх нэгжид
 *                     явагддаг (журам), харин 1-3 дугаар шат нь
 *                     нэгжийн ДОТООД хяналт. Эрхээр дангаар өргөсгөвөл
 *                     1-3 дугаар шат эхлүүлэхэд ч бусад нэгж гарч
 *                     ирдэг байв (2026-10-15 ухралт).
 *
 *                     Шат солигдоход жагсаалт ДАХИН татагдаж, хуучин
 *                     сонголт жагсаалтад үлдээгүй бол (ж: IV→II)
 *                     өөрийн нэгж рүү буцаана.
 */
const DepartmentTseh = (props) => {
  const { user, checkGroup, isAdmin } = useUserContext();
  const [list, setList] = useState([]);

  // sso_owner админ — бүх бүтцийн нэгжийг харна: "Бүгд" сонголт үргэлж гарч,
  // өөрийн цехийг анхдагчаар сонгохгүй (жагсаалт "Бүгд" төлөвт хэвээр).
  const admin = !!(isAdmin && isAdmin());

  // ХАБЭА хэлтэс / админ бүлгүүд (173/174/240/380) — тэдний ажил үүрэг нь
  // БҮХ нэгжийн хяналт тул "Бүгд" сонголт өгдөг. Group 167 (дунд шатны
  // удирдлага) хасагдана — зөвхөн өөрийн нэгжүүдээр.
  //
  // ⚠ Өмнө нь эдгээр хэрэглэгчид "Бүгд" сонголт ХАРАГДДАГ мөртлөө өөрсдийнх
  //   нь цех рүү автоматаар сонгогддог байсан тул жагсаалт нээгдэхэд бусад
  //   нэгжийн бүртгэл шүүгдэж хоцордог байв (ж: хяналт шалгалтын жагсаалт).
  //   Одоо "Бүгд" харах эрхтэй бүх хэрэглэгчид авто-сонголт хийхгүй.
  const seesAll =
    admin || (checkGroup([173, 174, 240, 380]) && !checkGroup([167]));

  // «Бүгд» сонголт жагсаалтад орох эсэх — ерөнхий дүрэм ЭСВЭЛ эцэг хуудас
  // `showAll`-оор шууд зөвшөөрсөн (ж: ХСБ-ний тайлан).
  const hasAllOption = seesAll || !!props.showAll;

  /* Кодоор item олох — `nameOnly` үеийн хайлтад (доорх filterOption). */
  const byCode = (code) =>
    _.find(list, (x) => String(x.departmentcode) === String(code));

  // Сонгогдсон цехийн item-ийг олж бүрэн мэдээллийг эцэгт буцаах
  const emitChange = (code, currentList) => {
    if (!props.onChange) return;
    if (code === undefined || code === null || code === "") {
      props.onChange("", null, "");
      return;
    }
    const item = _.find(
      currentList || list,
      (x) => String(x.departmentcode) === String(code),
    );
    props.onChange(
      code,
      item ? (item.id ?? null) : null,
      item ? item.departmentname : "",
    );
  };

  useLayoutEffect(() => {
    let mounted = true; // unmount болсны дараа setState хийхээс сэргийлнэ

    // Backend алдаа гарвал ч user.info-аас fallback хэрэглэх:
    // ЗӨВХӨН tseh_code (цех)-ийг нэмнэ — department_code (хэсэг) нь
    // DepartmentNegj-н харьяа учраас Цех dropdown-руу оруулахгүй.
    const buildFromUserInfo = () => {
      const opts = [];
      const tsehCode = user?.info?.tseh_code;
      if (tsehCode) {
        opts.push({
          departmentcode: tsehCode,
          departmentname: user?.info?.tseh_namemn || String(tsehCode),
          id: tsehCode,
          departmentlevelid: 3,
        });
      }
      return opts;
    };

    const handleResult = (res) => {
      if (!mounted) return;
      var result = Array.isArray(res) ? [...res] : [];

      // "Бүгд" сонголт — ХАБЭА хэлтэс / админ (173/174/240/380) хэрэглэгчдэд,
      // эсвэл эцэг хуудас `showAll` өгсөн бол.
      // Group 167 (дунд шатны удирдлага) болон бусад хязгаарлагдмал
      // хэрэглэгчдэд "Бүгд" харагдахгүй — зөвхөн өөрийн нэгжүүдээр.
      if (hasAllOption) {
        result.push({
          departmentcode: 0,
          departmentlevelid: 2,
          departmentname: "Бүгд",
          id: 0,
          paranetid: 0,
        });
      }

      let filtered = _.orderBy(
        _.filter(
          result,
          (a) => a.departmentlevelid > 1 && a.departmentlevelid < 5,
        ),
        ["departmentcode"],
      );

      // Backend buurguy fallback — user.info-аас өөрийн нэгжүүдийг нэмэх
      const fromInfo = buildFromUserInfo();
      fromInfo.forEach((entry) => {
        if (
          !_.some(
            filtered,
            (x) => String(x.departmentcode) === String(entry.departmentcode),
          )
        ) {
          filtered = [entry, ...filtered];
        }
      });

      setList(filtered);

      // Анхдагч сонголт — хэрэглэгчийн өөрийн цех.
      // "Бүгд" харах эрхтэй хэрэглэгчид (админ, ХАБЭА хэлтэс) авто-сонголт
      // хийхгүй — жагсаалт бүх нэгжийг харуулах "Бүгд" (filterDept="")
      // төлөвт үлдэнэ.
      const myTsehCode = user?.info?.tseh_code;

      // ⚠ ХҮЧИНГҮЙ БОЛСОН СОНГОЛТЫГ БУЦААХ (2026-10-15)
      //   `stage` солигдоход жагсаалт нарийсдаг (IV → бүх нэгж,
      //   II → зөвхөн өөрийнх). Сонгогдсон нэгж шинэ жагсаалтад
      //   БАЙХГҮЙ бол Select нь хоосон мэт харагдаад, эцэг хуудас нь
      //   хүрээнээс ГАДНА кодоор хүсэлт явуулсаар байх байв.
      //
      // ⚠ ЗӨВХӨН `stage` өгсөн дуудагчид. DepartmentTseh-ийг 20+ хуудас
      //   хэрэглэдэг бөгөөд тэдний зарим нь жагсаалтад байхгүй кодыг
      //   (ж: лавлахаас хассан хуучин нэгж) албаар `value`-д тавьдаг.
      //   Бүгдэд үйлчилбэл тэр хуудсуудын сонголт чимээгүй сольж
      //   орхино.
      const stale =
        props.stage !== undefined &&
        props.value !== undefined &&
        props.value !== null &&
        String(props.value) !== "" &&
        !_.some(
          filtered,
          (x) => String(x.departmentcode) === String(props.value),
        );
      if (stale) {
        const own = _.find(
          filtered,
          (x) => String(x.departmentcode) === String(myTsehCode),
        );
        emitChange(own ? own.departmentcode : "", filtered);
        return;
      }

      // `autoSelectOwn` өгсөн бол seesAll хэрэглэгчид ч өөрийн цех сонгогдоно
      const wantAuto = !seesAll || props.autoSelectOwn;
      if (wantAuto && !props.value && !props.noAutoSelect && myTsehCode) {
        const department = _.find(
          filtered,
          (x) => String(x.departmentcode) === String(myTsehCode),
        );
        if (department) {
          emitChange(department.departmentcode, filtered);
        }
      }
    };

    API.getUserDepartment(props.stage)
      .then(handleResult)
      .catch((err) => {
        // Backend алдаа — user.info-аас зөвхөн өөрийн нэгжүүдийг харуулна
        console.warn("getUserDepartment failed:", err?.message || err);
        handleResult([]);
      });

    return () => {
      mounted = false;
    };
    // ⚠ `props.stage` нь хамаарал. Шат солигдоход backend-ээс ШИНЭ
    //   хамрах хүрээг дахин татах ёстой — эс бөгөөс IV шатнаас II рүү
    //   буцахад бүх нэгж жагсаалтад үлдэнэ.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.stage]);

  return (
    <Select
      showSearch
      allowClear
      size={props.size}
      // Дашбоард зэрэг «хоосон = БҮХ нэгж» гэсэн утгатай хуудсанд «Сонгоно уу.»
      // гэдэг нь сонгогдоогүй мэт ойлгогдоно. Эцэг хуудас өөрийн утгыг өгнө.
      // ⚠ Анхдагч текст нь ЮУГ сонгохыг заана — хажууд хэсэг, төрөл, төлөв
      //   зэрэг өөр сонгогчид байхад «Сонгоно уу.» гэдэг нь алийг нь ч
      //   заахгүй тул хэрэглэгч андуурдаг байв.
      placeholder={props.placeholder || "БН-н сонголт хийнэ үү..."}
      /* ⚠ `nameOnly` үед `optionFilterProp="children"`-ийг ХЭРЭГЛЭХГҮЙ:
           харагдах текстээс код хасагдвал КОДООР хайх боломж ч алга
           болно. Тиймээс кодыг ч, нэрийг ч хайдаг `filterOption`. */
      {...(props.nameOnly
        ? {
            filterOption: (input, opt) => {
              const t = String(input || "").toLowerCase();
              const it = byCode(opt?.value);
              return (
                String(opt?.value || "").toLowerCase().includes(t) ||
                String(it?.departmentname || "").toLowerCase().includes(t)
              );
            },
          }
        : { optionFilterProp: "children" })}
      className="w-full"
      value={props.value}
      disabled={props.disabled}
      onChange={(code) => emitChange(code)}
    >
      {_.map(list, (item) => (
        <Select.Option key={item.id} value={item.departmentcode}>
          {/* ⚠ `nameOnly` — ЗӨВХӨН НЭР (2026-11-05, хэрэглэгч:
              «цех хэсэг код харагдаж байна, нэр хэрэгтэй»).
              ⚠ АНХДАГЧААР ХУУЧНААР («код | нэр»): энэ сонгогчийг 69
                хуудас хэрэглэдэг бөгөөд кодыг баримттай тулгахад
                хэрэглэдэг газар бий. Иймд дуудагч ИЛТ асаана. */}
          {props.nameOnly
            ? item.departmentname
            : `${item.departmentcode} | ${item.departmentname}`}
        </Select.Option>
      ))}
    </Select>
  );
};

export default React.memo(DepartmentTseh);
